import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { unauthHeaders } from '../../utils/API';
import { ErrorAlert } from '../../utils/Alerts';
import Appointments from './Appointments';
import UserContext from '../../UserContext';
import ConnfirmDeleteAppoinnmentModal from './ConnfirmDeleteAppoinnmentModal';

const AppointmentsContainer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [appointments, setAppointments] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [deletingAppointmentId, setDeletingAppointmentId] = useState('');

  const { setCurrentMenuItem } = useContext(UserContext);

  const getAppointments = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_API}api/v1.0/schedule/appointments?userId=${sessionStorage.getItem('userId')}`, {
      headers: {
        ...unauthHeaders,
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      }
    })
      .then((res) => {
        setIsLoading(false);
        setAppointments(res.data);
      })
      .catch((err) => {
        console.log(err);
        setErrorMessage(err.response.data.message);
        setIsLoading(false);
      });
  }

  const deleteAppointment = (id) => {
    setIsLoading(true);
    setDeletingAppointmentId('');
    axios.delete(`${process.env.REACT_APP_API}api/v1.0/schedule/appointments/${id}?userId=${sessionStorage.getItem('userId')}`, {
      headers: {
        ...unauthHeaders,
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      }
    })
      .then((res) => {
        setIsLoading(false);
        getAppointments();
      })
      .catch((err) => {
        console.log(err);
        setErrorMessage(err.response.data.message);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getAppointments();
    setCurrentMenuItem('appointments');
  }, [])

  const deleteAppointments = (id) => {
    handleClickOpenConfirmDialog()
    setDeletingAppointmentId(id);
  }

  const handleClickOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
    setDeletingAppointmentId('');
  };

  const handleConfirmDeleteAppointment = () => {
    deleteAppointment(deletingAppointmentId);
    setOpenConfirmDialog(false);
  }

  return (
    <>
      {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
      <Appointments
        isLoading={isLoading}
        appointments={appointments}
        deleteAppointments={deleteAppointments}
      />
      <ConnfirmDeleteAppoinnmentModal
        open={openConfirmDialog}
        handleClose={handleCloseConfirmDialog}
        handleConfirm={handleConfirmDeleteAppointment}
      />
    </>
  )
}

export default AppointmentsContainer;
